const STORAGE_KEY = 'delegonReturnTo';

export const isAppPath = (path) => /^\/app(\/|$|[?#])/.test(path ?? '');

export const rememberReturnTo = (path) => {
  if (!isAppPath(path)) {
    return;
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch {}
};

export const peekReturnTo = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const clearReturnTo = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
};

export const takeReturnTo = () => {
  const path = peekReturnTo();
  clearReturnTo();
  return path;
};
